import styled, { css } from 'styled-components';
import { getTypographyStyles } from '@oneaudi/unified-web-common';
import { ProgressIndicator } from '../progress-indicator/index.js';
import { getMargins, SYS_SIZE_FIXED_1400, SYS_SIZE_FIXED_1200, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_400, SEM_TYPOGRAPHY_ACTION_MD_LABEL, SEM_TYPOGRAPHY_ACTION_SM_LABEL } from '@oneaudi/unified-web-common';
export const StyledButton = styled.button `
  ${(props) => props.isLoading &&
    css `
      position: relative;
    `}
  margin: ${(props) => getMargins(props.margin)};
  border: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // TODO: missing token
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color, background-color, box-shadow, border-radius;
  background-color: ${(props) => props.theme.sem.color.action.primary.surface.fill.default};
  color: ${(props) => props.theme.sem.color.action.primary.foreground.text.default};

  ${(props) => {
    if (props.disabled && !props.isLoading) {
        return css `
        cursor: not-allowed;
      `;
    }
    if (props.isLoading) {
        return css `
        cursor: progress;
      `;
    }
    return css `
      cursor: pointer;
    `;
}}

  svg {
    flex-shrink: 0;
  }

  ${(props) => props.as === 'a'
    ? css `
          display: inline-flex;
          box-sizing: border-box;
          text-align: center;
        `
    : css `
          display: flex;
          border: 0;
        `}

  ${(props) => !props.isLoading &&
    css `
      &:hover {
        background-color: ${props.theme.sem.color.action.primary.surface.fill
        .hover};
        color: ${props.theme.sem.color.action.primary.foreground.text.hover};
      }

      &:active {
        background-color: ${props.theme.sem.color.action.primary.surface.fill
        .pressed};
        color: ${props.theme.sem.color.action.primary.foreground.text.pressed};
      }
    `}

      ${(props) => props.size === 'md'
    ? css `
          ${getTypographyStyles(SEM_TYPOGRAPHY_ACTION_MD_LABEL)}
          padding: ${SYS_SPACE_FIXED_200} ${SYS_SPACE_FIXED_400};
          min-height: ${SYS_SIZE_FIXED_1400};
        `
    : css `
          ${getTypographyStyles(SEM_TYPOGRAPHY_ACTION_SM_LABEL)}
          padding: ${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_300};
          min-height: ${SYS_SIZE_FIXED_1200};
        `}


  ${(props) => props.isFullWidth &&
    css `
      width: 100%;
    `}

  ${(props) => props.as === 'button' &&
    !props.isLoading &&
    css `
      &:disabled {
        background-color: ${(props) => props.theme.sem.color.action.primary.surface.fill.disabled};
        color: ${(props) => props.theme.sem.color.action.primary.foreground.text.disabled};
      }
    `}

  ${(props) => props.variant === 'secondary' &&
    css `
      background-color: ${props.theme.sem.color.action.secondary.surface.fill
        .default};
      color: ${props.theme.sem.color.action.secondary.foreground.text.default};
      box-shadow: inset 0 0 0 1px
        ${props.theme.sem.color.action.secondary.surface.stroke.default};

      ${!props.isLoading &&
        css `
        &:hover {
          background-color: ${props.theme.sem.color.action.secondary.surface
            .fill.hover};
          color: ${props.theme.sem.color.action.secondary.foreground.text
            .hover};
          box-shadow: inset 0 0 0 1px
            ${props.theme.sem.color.action.secondary.surface.stroke.hover};
        }

        &:active {
          background-color: ${props.theme.sem.color.action.secondary.surface
            .fill.pressed};
          color: ${props.theme.sem.color.action.secondary.foreground.text
            .pressed};
          box-shadow: inset 0 0 0 1px
            ${props.theme.sem.color.action.secondary.surface.stroke.pressed};
        }
      `}

      ${props.as === 'button' &&
        !props.isLoading &&
        css `
        &:disabled {
          background-color: ${props.theme.sem.color.action.secondary.surface
            .fill.disabled};
          color: ${props.theme.sem.color.action.secondary.foreground.text
            .disabled};
          box-shadow: inset 0 0 0 1px
            ${props.theme.sem.color.action.secondary.surface.stroke.disabled};
        }
      `}
    `}

    ${(props) => props.variant === 'tertiary' &&
    css `
      background-color: ${props.theme.sem.color.action.tertiary.surface.fill
        .default};
      color: ${props.theme.sem.color.action.tertiary.foreground.text.default};

      ${!props.isLoading &&
        css `
        &:hover {
          background-color: ${props.theme.sem.color.action.tertiary.surface.fill
            .hover};
          color: ${props.theme.sem.color.action.tertiary.foreground.text.hover};
        }

        &:active {
          background-color: ${props.theme.sem.color.action.tertiary.surface.fill
            .pressed};
          color: ${props.theme.sem.color.action.tertiary.foreground.text
            .pressed};
        }
      `}

      ${props.as === 'button' &&
        !props.isLoading &&
        css `
        &:disabled {
          background-color: ${props.theme.sem.color.action.tertiary.surface.fill
            .disabled};
          color: ${props.theme.sem.color.action.tertiary.foreground.text
            .disabled};
        }
      `}
    `}
`;
export const StyledButtonContent = styled.span `
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${SYS_SPACE_FIXED_150};

  ${(props) => props.isLoading &&
    css `
      opacity: 0;
      visibility: hidden;
      height: 0;
      pointer-events: none;
    `}
`;
export const StyledProgressIndicator = styled(ProgressIndicator) `
  position: absolute;
`;
//# sourceMappingURL=index.styles.js.map